<template>
  <div class="box">
    <!-- <div class="header-bar">
      <div class="header-content">
        <van-icon name="description" size="48" color="#FFF" />
        <div class="header-title">批次详情</div>
        <div class="header-count" v-if="filteredList.length > 0">{{ filteredList.length }}人</div>
      </div>
      <div class="header-actions">
        <div class="refresh-btn" @click="handleRefresh">
          <van-icon name="replay" size="32" color="#FFF" />
        </div>
      </div>
    </div> -->
    <!-- <div class="filter-bar">
      <van-dropdown-menu active-color="#E99D42">
        <van-dropdown-item v-model="selectedVillage" :options="villageOptions" @change="handleSelected" />
      </van-dropdown-menu>
    </div> -->
    <div class="content">
      <div class="side-bar">
        <van-sidebar v-model="selectedVillage">
          <van-sidebar-item v-for="item in villageOptions" :key="item.value" :title="item.text" @click="handleChange(item)" />
        </van-sidebar>
      </div>
      <div class="publicity-list">
        <van-empty class="empty-box" v-if="publicityList.length === 0 && !loading" description="暂无公示数据" />
        <van-list v-else v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="publicity-item" v-for="(item, index) in publicityList" :key="index">
            <img :src="item.villagePhotoUrl" alt="" @click="handlePreview(item)" />
            <!-- <div class="item-header">
              <div class="item-number">{{ index + 1 }}</div>
              <div class="item-name">{{ item.userName }}</div>
              <div class="item-status" :class="getStatusClass(item.status)">
                <van-icon :name="getStatusIcon(item.isCompleted)" size="16" />
                <span>{{ getStatusText(item.isCompleted) }}</span>
              </div>
            </div>
            <div class="item-content">
              <div class="info-row-container">
                <div class="info-row" v-if="item.policyholder">
                  <van-icon name="location-o" size="24" color="#1890ff" />
                  <div class="info-text">
                    <span class="info-label">村落</span>
                    <span class="info-value">{{ item.policyholder }}</span>
                  </div>
                </div>
                <div class="info-row" v-if="item.insuranceMethod">
                  <van-icon name="orders-o" size="24" color="#E99D42" />
                  <div class="info-text">
                    <span class="info-label">投报方式</span>
                    <span class="info-value">{{ item.insuranceMethod }}</span>
                  </div>
                </div>
              </div>
            </div> -->
          </div>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
import { getVillage, getPublicityList } from '@/service/insurance'
export default {
  name: 'BatchDetail',
  props: {},
  data() {
    return {
      id: this.$route.query.id,
      publicityList: [],
      selectedVillage: '',
      selectedVillageId: '',
      page: 1,
      pageSize: 10,
      loading: false,
      finished: false,
      villageOptions: [
        // { text: '全部村落', value: '' },
        // { text: '垟根村', value: '垟根村' },
        // { text: '樟岙村', value: '樟岙村' },
        // { text: '扫帚山村', value: '扫帚山村' },
        // { text: '芳斗村', value: '芳斗村' },
        // { text: '前赵村', value: '前赵村' },
        // { text: '蒲田村', value: '蒲田村' },
        // { text: '苔山塘', value: '苔山塘' },
        // { text: '湿地', value: '湿地' }
      ]
    }
  },
  mounted() {
    // 获取列表
    this.getAllVillage()
    this.getPublicityListData()
  },
  computed: {},
  methods: {
    handlePreview(item) {
      console.log(item)
      this.$imagePreview([item.villagePhotoUrl])
    },
    getAllVillage() {
      getVillage(this.id).then((res) => {
        if (res && Array.isArray(res.data)) {
          this.villageOptions = [
            { text: '全部村落', value: '' },
            ...res.data.map((village) => ({
              text: village.villageName,
              value: village.villageId
            }))
          ]
          console.log(this.villageOptions, 'villageOptions')
        }
      })
    },
    handleChange(val) {
      console.log(val)
      this.selectedVillageId = val.value
      this.page = 1
      this.publicityList = []
      this.finished = false
      this.getPublicityListData()
    },
    handleSelected(item) {
      this.selectedVillage = item
      this.page = 1
      this.publicityList = []
      this.finished = false
      this.getPublicityListData()
    },
    handleRefresh() {
      this.$toast.loading({
        message: '刷新中...',
        forbidClick: true,
        duration: 0
      })
      this.getPublicityListData()
      setTimeout(() => {
        this.$toast.clear()
        this.$toast.success('刷新完成')
      }, 1000)
    },
    getStatusText(isCompleted) {
      return isCompleted === 1 || isCompleted === '1' ? '已完成' : '未完成'
    },
    getStatusIcon(isCompleted) {
      return isCompleted === 1 || isCompleted === '1' ? 'checked' : 'clock-o'
    },
    getStatusClass(isCompleted) {
      return isCompleted === 1 || isCompleted === '1' ? 'status-completed' : 'status-pending'
    },
    getPublicityListData() {
      if (!this.id) {
        console.warn('批次ID不存在')
        return
      }
      this.loading = true
      let batchId = this.id
      let villageId = this.selectedVillageId
      // 获取公示人员
      getPublicityList(batchId, villageId, this.page, this.pageSize)
        .then((res) => {
          console.log(res, 'API响应')
          const rows = (res && res.rows) || []
          if (rows.length > 0) {
            // 追加数据以支持分页
            this.publicityList = this.publicityList.concat(rows)
            console.log('成功加载数据:', this.publicityList.length, '项')
            // 如果返回数量少于每页大小，则结束；否则准备下一页 或者this.publicityList.length == total
            if (rows.length < this.pageSize || this.publicityList.length == res.total) {
              this.finished = true
            } else {
              this.page += 1
            }
          } else {
            // 无数据时标记完成
            this.finished = true
          }
          this.loading = false
        })
        .catch((err) => {
          console.error('获取公示列表失败:', err)
          this.loading = false
          this.finished = true
        })
    },
    // van-list 触发加载
    onLoad() {
      if (this.finished) return
      this.getPublicityListData()
    }
  }
}
</script>
<style lang="stylus" scoped>
.box{
  position relative
  overflow-x hidden
  -webkit-overflow-scrolling touch
  background linear-gradient(180deg, #f8f9fa 0%, #f5f5f5 100%)
  padding-bottom 40px
}
.content{
  display: flex
  .side-bar{
    width: 400px
    min-height 100vh
    height 100vh
    overflow-y auto
  }
}
.header-bar{
  background linear-gradient(135deg, #E99D42 0%, #ffb366 100%)
  padding 30px 30px 40px 30px
  box-shadow 0 4px 20px rgba(233, 157, 66, 0.2)
  position relative

  .header-content{
    display flex
    align-items center
    flex-direction column

    .header-title{
      color #fff
      font-size 32px
      font-weight bold
      margin-top 16px
      text-shadow 0 2px 4px rgba(0, 0, 0, 0.1)
    }

    .header-count{
      background rgba(255, 255, 255, 0.3)
      color #fff
      padding 6px 18px
      border-radius 16px
      font-size 20px
      margin-top 12px
      font-weight 500
      backdrop-filter blur(10px)
    }
  }

  .header-actions{
    position absolute
    top 30px
    right 30px

    .refresh-btn{
      width 48px
      height 48px
      background rgba(255, 255, 255, 0.2)
      border-radius 50%
      display flex
      align-items center
      justify-content center
      transition all 0.3s ease
      backdrop-filter blur(10px)
      cursor pointer

      &:active{
        transform scale(0.95)
        background rgba(255, 255, 255, 0.3)
      }

      &:hover{
        background rgba(255, 255, 255, 0.3)
      }
    }
  }
}

.search-bar{
  padding 20px 20px 0 20px
  background #fff
  box-shadow 0 2px 8px rgba(0, 0, 0, 0.04)
}

.filter-bar{
  background #fff
  padding 10px 20px
  box-shadow 0 2px 8px rgba(0, 0, 0, 0.04)
  margin-bottom 20px
  min-height 48px

  /deep/ .van-dropdown-menu{
    position relative
    display block
  }

  /deep/ .van-dropdown-menu__bar{
    box-shadow none
  }
}

.publicity-list{
  padding 20px
  min-height 100vh
  height 100vh
  overflow-y auto
  /* 针对 WebKit 浏览器隐藏滚动条 */
  scrollable::-webkit-scrollbar {
    display: none;
  }
  .empty-box{
    margin-top 100px
  }
  .publicity-item{
    background #fff
    border-radius 16px
    margin-bottom 16px
    box-shadow 0 2px 12px rgba(0, 0, 0, 0.06)
    overflow hidden
    transition all 0.3s cubic-bezier(0.4, 0, 0.2, 1)
    border 1px solid transparent
    max-width: 1400px

    &:active{
      transform translateY(1px)
      box-shadow 0 1px 6px rgba(0, 0, 0, 0.10)
    }

    &:hover{
      border-color rgba(233, 157, 66, 0.3)
      box-shadow 0 4px 16px rgba(233, 157, 66, 0.12)
    }

    .item-header{
      background linear-gradient(135deg, rgba(233, 157, 66, 0.08) 0%, rgba(255, 179, 102, 0.08) 100%)
      padding 16px 20px
      display flex
      align-items center
      border-bottom 1px solid #f0f0f0

      .item-number{
        width 44px
        height 44px
        background linear-gradient(135deg, #E99D42 0%, #ffb366 100%)
        color #fff
        font-size 22px
        font-weight bold
        border-radius 10px
        display flex
        align-items center
        justify-content center
        box-shadow 0 2px 8px rgba(233, 157, 66, 0.3)
      }

      .item-name{
        font-size 28px
        font-weight bold
        color #333
        margin-left 12px
        flex 1
      }

      .item-status{
        display flex
        align-items center
        gap 4px
        padding 4px 10px
        border-radius 10px
        font-size 18px
        font-weight 500

        &.status-completed{
          background linear-gradient(135deg, #f6ffed 0%, #d4f3d1 100%)
          color #52c41a
          border 1px solid #b7eb8f
        }

        &.status-pending{
          background linear-gradient(135deg, #fff7e6 0%, #fff4d9 100%)
          color #fa8c16
          border 1px solid #ffecc7
        }

        span{
          font-size 18px
        }
      }
    }

    .item-content{
      padding 18px 20px

      .info-row-container{
        display flex
        gap 16px

        .info-row{
          flex 1
          display flex
          align-items center
          padding 0

          .info-text{
            flex 1
            margin-left 12px
            display flex
            flex-direction column
            align-items flex-start

            .info-label{
              font-size 20px
              color #999
              margin-bottom 6px
            }

            .info-value{
              font-size 24px
              color #333
              font-weight 500
              line-height 1.4
              word-break break-all
            }
          }
        }
      }
    }
  }
}
</style>
